import React, { Component } from 'react'
import axios from 'axios';
const Context = React.createContext();

const reducer = (state,action) => {
    switch(action.type) {
        case "SEARCH_TRACK":
            return{
                ...state,
                heading: 'Search Results:',
                track_list_in: action.payload,
            }
        default: 
            return state
    }
}

export class Provider extends Component {

    state = {
        track_list_in: [],
        heading: 'Top Tracks in India',
        dispatch: action => this.setState(state => reducer(state,action))
    }

    componentDidMount() {
        axios.get(`https://cors-anywhere.herokuapp.com/https://api.musixmatch.com/ws/1.1/chart.tracks.get?chart_name=top&page=1&page_size=10&country=in&f_has_lyrics=1&apikey=${process.env.REACT_APP_API_KEY}`)
            .then(res => {
                this.setState({track_list_in: res.data.message.body.track_list})
            })
            .catch(error => console.log(error))
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        )
    }
}

export const Consumer = Context.Consumer;